import {
  Box,
  Button,
  Grid,
  IconButton,
  Typography,
} from "@material-ui/core";
import React, { useState } from "react";
import cardBgBlue from "../../Images/CardBgBlue.png";
import cardBgPurple from "../../Images/CardBgPurple.png";
import { useNavigate } from "react-router-dom";
import { useThemeColors } from "../../Context/Theme";

const CategoryOffer = ({
  offerImages,
  isMobile,
  isTablet,
  isLoading,
  isError,
  eventName,
}) => {
  const {
    fontFamily,
    fontSize,
    fontFamilyHeading,
    fontWeightHeading,
    fontSizeHeading
  } = useThemeColors();

  const categoryOfferData = offerImages?.data?.filter((i) => {
    const currentDate = new Date();
    const offerEndDate = new Date(i.offer_end_date);
    offerEndDate.setHours(23, 59, 59, 999);
    return i.category.category_id !== null && offerEndDate >= currentDate;
  });

  const navigate = useNavigate();
  const carouselData =
    categoryOfferData?.map((offer) => offer?.offer_img_path).slice(0, 3) || [];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [showNavigation, setShowNavigation] = useState(false);
  const [isDescriptionExpanded, setIsDescriptionExpanded] = useState(false);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % carouselData.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? carouselData.length - 1 : prevIndex - 1
    );
  };

  if (!isMobile) {
    return (
      <div
        className="event_categoryOffer fo_css_event_categoryOffer_mobile"
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: isMobile ? "flex-start" : "flex-start",
          alignItems: "center",
          width: "100%",
          borderRadius: "1rem",
          maxWidth: "91.6%",


          marginBottom: "0.7%",
          height: isTablet ? "40vh" : "30vh",
          maxHeight: "40vh",
          margin: "1.5em auto",

          overflow: 'auto',
          scrollbarWidthh: "none",
          msOverflowStyle: "none",

        }}
      >
        {categoryOfferData?.map((item, index) => (
          <div
            className="fo_css_event_categoryOffer_mobile_card"
            style={{
              background: `url(${index % 2 === 0 ? cardBgBlue : cardBgPurple})`,
              height: "100%",
              minHeight: "100%",
              width: isMobile ? "100%" : "30vw",
              minWidth: isMobile ? "100%" : "30vw",
              maxHeight: "40vh",
              backgroundSize: "cover",
              backgroundPosition: "center",
              cursor: "pointer",
              borderRadius: "1rem",
              position: "relative",
              overflow: "hidden",
              marginRight: "1rem",
              padding: "24px",
            }}
            // onClick={() =>
            //   navigate(`/events/${eventName}/shop`, {
            //     state: { category: item?.category?.category_id },
            //   })
            // }
          >
            <Grid
              container
              style={{
                width: "100%",
                height: "100%",
                minHeight: "100%",
                maxHeight: "100%",
              }}
            >
              <Grid
                item
                xs={8}
                style={{
                  minHeight: "100%",
                  maxHeight: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
              >
                <Box
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    height: "100%",
                  }}
                >
                  <Typography
                    style={{
                      color: "black",

                      fontSize: fontSizeHeading || (isTablet ? "18px" : "2vw"),
                      fontWeight: fontWeightHeading || "600",
                      textOverflow: "ellipsis",
                      whiteSpace: "wrap",
                      overflow: isDescriptionExpanded ? "auto" : "hidden",
                      fontFamily: fontFamilyHeading,
                      maxHeight: "7.5rem",
                      // maxHeight: "7.5rem", 
                      // overflow: "hidden", 
                      // textOverflow: "ellipsis"
                    }}
                  >
    {isDescriptionExpanded ? item?.discription : item?.discription.substring(0, 170) + "..."}

                    {/* {item?.discription} */}
                  
                  {item?.discription.length > 170 && (
    <span
      style={{
        color: "black",
        fontSize: fontSize || '1.2vw',
        fontFamily,
        textDecoration: "underline",
        cursor: "pointer",
        // float: "right",
      }}
      onClick={() => setIsDescriptionExpanded(!isDescriptionExpanded)}
    >
      {isDescriptionExpanded ? "See Less" : "See More"}
    </span>
  )}
  </Typography>

                </Box>
                <Box style={{
                  height: "30%",
                  width: '80%'
                }}>
                  <Button
                    variant="outlined"
                    style={{
                      marginTop: "1rem",
                      backgroundColor: "white",
                      color: "black",
                      height: '100%',
                      width: "100%",
                      fontFamily,
                      fontSize: fontSize || '1.2vw',
                      borderRadius: "0.6rem",
                      border: "none",
                    }}
                      onClick={() =>
              navigate(`/events/${eventName}/shop`, {
                state: { category: item?.category?.category_id },
              })
            }
                  >
                    Order Now
                  </Button>
                </Box>
              </Grid>
              <Grid
                item
                xs={4}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <img
                  src={item?.offer_img_path}
                  alt=""
                  style={{ width: "70%", minHeight: "100%", objectFit: "fill" }}
                />
              </Grid>
            </Grid>
          </div>
        ))}
      </div>
    );
  }

  return (
    <>
      {categoryOfferData?.length > 0 ? (
        <Box
          className="fo_css_event_categoryOffer_content"
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "30vh",
            maxHeight: "max-content",
            width: "max-content",
            minWidth: "91.6%",
            maxWidth: "91.6%",
            position: "relative",
            overflow: "hidden",
            borderRadius: "1rem",
            margin: "1.5rem auto",
          }}
          onMouseOver={() => {
            setShowNavigation(true);
          }}
          onMouseLeave={() => {
            setShowNavigation(false);
          }}
        >
          <Box
            style={{
              backgroundImage: `url(${currentIndex % 2 ? cardBgPurple : cardBgBlue
                })`,
              height: "100%",
              minHeight: "100%",
              maxHeight: "max-content",
              width: isMobile ? "100%" : "28vw",
              minWidth: "100%",
              backgroundSize: "cover",
              backgroundPosition: "center",
              cursor: "pointer",
              borderRadius: "1rem",
              position: "relative",
              overflow: "hidden",
              padding: "1rem",
            }}
            onClick={() =>
              navigate(`/events/${eventName}/shop`, {
                state: {
                  category:
                    categoryOfferData?.[currentIndex]?.category?.category_id,
                },
              })
            }
          >
            <Grid
              container
              style={{
                width: "100%",
                height: "100%",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Grid
                item
                xs={12}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "space-between",
                  height: "100%",
                  maxHeight: "100%",
                }}
              >
                <Typography
                  style={{
                    color: "black",
                    fontSize: "16px",
                    fontWeight: "600",
                    textAlign: "center",
                    fontFamily: fontFamilyHeading
                  }}
                >
                  {categoryOfferData?.[currentIndex]?.discription}
                </Typography>
                <Box sx={{ height: "50%", maxHeight: "max-content" }}>
                  <img
                    src={categoryOfferData?.[currentIndex]?.offer_img_path}
                    style={{ height: "100%", objectFit: "fill" }}
                    alt=""
                  />
                </Box>
                <Button
                  variant="outlined"
                  style={{
                    marginTop: "1rem",
                    backgroundColor: "white",
                    color: "black",
                    width: "100%",
                    maxWidth: "max-content",
                    borderRadius: "0.6rem",
                    border: "none",
                  }}
                >
                  Order Now
                </Button>
              </Grid>
            </Grid>
          </Box>

          {/* Navigation Buttons */}
          <IconButton
            onClick={prevSlide}
            style={{
              position: "absolute",
              top: "50%",
              left: "5%",
              transform: "translateY(-50%)",
              color: "white",
              bgcolor: "rgba(0, 0, 0, 0.4)",
              "&:hover": { bgcolor: "rgba(0, 0, 0, 0.6)" },
              color: "black",
              opacity: "0.5",
            }}
          >
            {"<"}
          </IconButton>

          <IconButton
            onClick={nextSlide}
            style={{
              position: "absolute",
              top: "50%",
              right: "5%",
              transform: "translateY(-50%)",
              color: "white",
              bgcolor: "rgba(0, 0, 0, 0.4)",
              "&:hover": { bgcolor: "rgba(0, 0, 0, 0.6)" },
              color: "black",
              opacity: "0.5",
            }}
          >
            {">"}
          </IconButton>
        </Box>
      ) : (
        ""
      )}
    </>
  );
};

export default CategoryOffer;
